<div class="page-header">
    <h2 id="commercialPropertyHeader">
        Commercial property information</h2>
</div>
<div [formGroup]="commercialPropertyForm">
    <div class="row form-group">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <label for="primaryCause">Primary cause of the incident or damage</label>
            <select class="form-control nw-input--medium" name="primaryCause" id="primaryCause" aria-required="true" aria-describedby="primaryCause" [formControl]="primaryCause"
                [ngClass]="{'has-error':(primaryCause.touched && primaryCause.invalid)}">
                <option value="" selected>Select</option>
                <option *ngFor="let primaryCause of primaryCauses">{{primaryCause}}</option>
            </select>
            <div *ngIf="primaryCause.touched && primaryCause.invalid" class="alert alert-danger nw-field-error" id="primaryCauseErrorId">
                <span id="primaryCauseRequiredErrorMessage">Required</span>
            </div>
        </div>
    </div>
    <div class="row form-group">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <fieldset>
                <legend>Select all areas of damage that apply</legend>
                <div class="checkbox" *ngFor="let damage of damages; let i=index">
                    <label>
                        <input type="checkbox" id="{{'damage' + i}}" [value]="damage.value" (click)="onDamageChange($event)">
                        {{damage.description}}
                    </label>
                </div>
            </fieldset>
            <div style="display:inline" *ngIf="damagedAreasList.invalid && damagedAreasList.touched" class="alert alert-danger nw-field-error" id="damagedAreasListErrorId">
                <span *ngIf="damagedAreasList.hasError('required')" id="damagedAreasListErrorMessage">Required</span>
            </div>
        </div>
    </div>
    <div id="totalAmountLostAnswerSection" class="row form-group">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <fieldset>
                <legend for="totalAmountLostAnswers">Total amount of loss or damage expected to be above $10,000?</legend>
                <div class="btn-group" data-toggle="buttons" id="totalAmountLostAnswers">
                    <label class="btn btn-default form-check-label" [ngClass]="{'active':(totalAmountLostAnswer.value ==='Yes')}">
                        <input name="totalAmountLostAnswer" class="form-check-input" type="radio" checked="totalAmountLostAnswer.value ==='Yes'" autocomplete="off" value="Yes"
                            [formControl]="totalAmountLostAnswer">Yes
                    </label>
                    <label class="btn btn-default form-check-label" [ngClass]="{'active':(totalAmountLostAnswer.value ==='No')}">
                        <input name="totalAmountLostAnswer" class="form-check-input" type="radio" checked="totalAmountLostAnswer.value ==='No'" autocomplete="off" value="No"
                            [formControl]="totalAmountLostAnswer">No
                    </label>
                    <label class="btn btn-default form-check-label" [ngClass]="{'active':(totalAmountLostAnswer.value ==='unknown')}">
                        <input name="totalAmountLostAnswer" class="form-check-input" type="radio" checked="totalAmountLostAnswer.value ==='unknown'" autocomplete="off" value="unknown"
                            [formControl]="totalAmountLostAnswer">I don't know
                    </label>
                </div>
                <div *ngIf="totalAmountLostAnswer.invalid && totalAmountLostAnswer.touched" class="alert alert-danger nw-field-error" id="totalAmountLostAnswerErrorId">
                    <span *ngIf="totalAmountLostAnswer.hasError('required')" id="totalAmountLostAnswerErrorMessage">Required</span>
                </div>
            </fieldset>
        </div>
    </div>
</div>